const tagsGroupConstants = {
    AD_SET: gettext('Ad Set'),
    AD_SETS: gettext('Ad Sets'),
    CAMPAIGN: gettext('Campaign'),
    CAMPAIGNS: gettext('Campaigns'),
    FACEBOOK_ADS: 'facebook_ads',
    TAGGED_CAMPAIGNS: 'tagged_campaigns',
    UNTAGGED: 'untagged',
    GOOGLE_ADS: 'google_ads',
};

export default tagsGroupConstants;
